import { render, staticRenderFns } from "./userorderdetails.vue?vue&type=template&id=8b0eca16&scoped=true&"
import script from "./userorderdetails.vue?vue&type=script&lang=js&"
export * from "./userorderdetails.vue?vue&type=script&lang=js&"
import style0 from "./userorderdetails.vue?vue&type=style&index=0&id=8b0eca16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b0eca16",
  null
  
)

export default component.exports